<router-outlet></router-outlet>
<app-lgpd-consent-request></app-lgpd-consent-request>
<app-license-session-lock></app-license-session-lock>

<app-diagnostic-summary></app-diagnostic-summary>

<ng-template #ticketCenterHeaderNav>
  <app-search-ticket-by-number-widget></app-search-ticket-by-number-widget>
</ng-template>
